module.exports = __webpack_public_path__ + "img/0.0ed56736.jpg";